import * as React from 'react';
export const IcPestProblem = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M16 13a4 4 0 014-4h.06a14.06 14.06 0 01.84-4.57 1 1 0 000-1A1 1 0 0020 3h-6a2 2 0 01-3.9.6C5.64 5.06 3 9.15 3 15c0 2.81.73 4.33 1.63 5.13a.252.252 0 00.311-.035A.25.25 0 005 20c.33-6 3.54-10.29 9.57-12.87a1 1 0 11.78 1.84C9.83 11.3 7.09 15.17 7 20.73a.27.27 0 00.27.27 19.198 19.198 0 004.37-.54A2 2 0 1115 19v.13a10.43 10.43 0 003.08-2.64A4 4 0 0116 13z'
      fill='currentColor'
    />
  </svg>
);
